var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0263 2.8335C6.94506 2.8335 2.82617 6.95239 2.82617 12.0336C2.82617 17.1148 6.94506 21.2337 12.0263 21.2337C17.1075 21.2337 21.2264 17.1148 21.2264 12.0336C21.2264 6.95239 17.1075 2.8335 12.0263 2.8335Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91602 17.8719C4.91602 17.8719 6.96672 15.2535 12.0268 15.2535C17.0868 15.2535 19.1385 17.8719 19.1385 17.8719M12.0268 12.0335C12.7588 12.0335 13.4608 11.7427 13.9784 11.2251C14.496 10.7075 14.7868 10.0055 14.7868 9.27346C14.7868 8.54145 14.496 7.83943 13.9784 7.32182C13.4608 6.80422 12.7588 6.51343 12.0268 6.51343C11.2948 6.51343 10.5928 6.80422 10.0751 7.32182C9.55754 7.83943 9.26675 8.54145 9.26675 9.27346C9.26675 10.0055 9.55754 10.7075 10.0751 11.2251C10.5928 11.7427 11.2948 12.0335 12.0268 12.0335Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ef7eccd2.svg";
export { ForwardRef as ReactComponent };